<template>
  <div class="profile-page">
    <p class="page-title">公司信息</p>
    <el-row :gutter="20">
      <el-col :span="6">
        <v-card>
          <h4 class="page-title1">公司信息</h4>
          <el-menu class="menu" :router="true" :default-active="routePath">
            <el-menu-item class="menu-item" index="/profile/info">
              <i class="fa fa-list-ul"></i>信息维护</el-menu-item>
            <el-menu-item class="menu-item" index="/profile/point">
              <i class="fa fa-list-ul"></i>服务网点维护</el-menu-item>
            <el-menu-item class="menu-item" index="/profile/engineer">
              <i class="fa fa-list-ul"></i>工程师维护</el-menu-item>
          </el-menu>
        </v-card>
        <v-card class="contract">
          <el-row class="row">
            <el-col :span="4">
              <i class="fa fa-phone"></i>
            </el-col>
            <el-col :span="20">
              <p style="line-height: 22px;">客户服务热线:0755-82405890
                <br>（人工服务时间：09:00-18:00）</p>
            </el-col>
          </el-row>
          <el-row class="row">
            <a href="http://wpa.qq.com/msgrd?v=3&uin=2850559846&site=qq&menu=yes" target="_blank" class="btn btn-qq">
              <el-col :span="4">
                <i class="fa fa-comments"></i>
              </el-col>
              <el-col :span="20" style="line-height: 44px;">在线客服</el-col>
            </a>
          </el-row>
        </v-card>
      </el-col>
      <el-col :span="18">
        <v-card>
          <router-view></router-view>
        </v-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import vCard from '@/components/common/Card'
export default {
  data() {
    return {
    }
  },
  computed: {
    routePath() {
      return this.$route.path
    },
  },
  components: {
    vCard,
  },
}
</script>

<style lang="less" scoped>
.profile-page {
  padding-left: 10px;
  padding-right: 10px;
}
.page-title1{font-size: 18px;padding-bottom: 20px;}
.contract {
  margin-top: 20px;
  padding: 30px;
  .row {
    height: 44px;
    font-size: 12px;
    &:last-child {
      margin-top: 20px;
    }
    p {
      margin: 0;
    }
    .fa {
      line-height: 44px;
      font-size: 28px;
      color: #20a0ff;
    }
  }
}

.menu {
  background-color: transparent;
  .menu-item {
    height: 46px;
    line-height: 46px;
    background-color: transparent;
    border-left: 4px solid transparent;
    color: #43484d;
    &.is-active {
      background-color: #e5e9f2;
      border-left: 4px solid #707070;
      color: #43484d;
    }
    .fa {
      margin-right: 10px;
    }
  }
}
</style>

<style lang="less">
.profile-page {
  .btn {
    background-color: #c8e7fd;
    width: 120px;
    height: 36px;
    font-size: 12px;
  }
  .el-button {
    border:none;
    border-color:#c8e7fd;
  }
}
</style>



// WEBPACK FOOTER //
// ProfilePage.vue?074b0ff7